<template>
	<footer id="footer" class="f5 relative overflow-hidden">
		<span id="widget-version" :title="widgetVersion">
			{{widgetVersion}}
		</span>
		<div
			:class="[ `container flex justify-between items-center flex-wrap`, $css(styles.container)]">
			<div :class="[`text-holder relative overflow-hidden`, $css(styles.textHolder)]">
				<p :class="$css(styles.p)">
					<a href="https://cloudinary.com" target="_blank">© {{year}} Cloudinary.</a> All rights reserved
				</p>
				<ul :class="[`footer-menu list flex fw7`, $css(styles.menu)]">
					<li :class="$css(styles.menuItem)"><a href="https://cloudinary.com/tos" target="_blank">Terms of use</a></li>
					<li :class="$css(styles.menuItem)"><a href="https://cloudinary.com/privacy" target="_blank">Privacy Policy</a></li>
					<li :class="$css(styles.menuItem)"><a href="https://cloudinary.com/documentation/upload_widget_2" target="_blank">UW Documentation</a></li>
				</ul>
			</div>
			<div :class="[`footer-logo`, $css(styles.footerLogo)]">
				<a href="https://cloudinary.com" target="_blank">
					<img src="../../assets/images/logo.svg" alt="Cloudinary">
				</a>
			</div>
		</div>
	</footer>
</template>

<script>
	import {mapState} from "vuex";
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";

	function styles() {
		return this.$style({
			container: gimq(
				[MQ_SIZES.M, {padding: "10px 15px 20px"}]),
			textHolder: gimq(MQ_SIZES.M, {
				width: "100%",
				textAlign: "center",
			}),
			p: gimq(MQ_SIZES.M, {
				margin: "0 0 12px"
			}),
			menu: gimq(MQ_SIZES.M, {
				justifyContent: "center",
				margin: "0 0 12px"
			}),
			menuItem: gimq(MQ_SIZES.M, {
				padding: "0 10px",
			}),
			footerLogo:gimq(MQ_SIZES.M, {
				display: "block",
				margin: "0 auto",
			}),
		});
	}

	export default {
		name: "Footer",
		computed: {
			...mapState({
				widgetVersion: (state) => (state.app.widgetLoaded ?
					`Upload Widget V2.${self.cloudinary.WIDGET_VERSION}` : "Loading..."),
			}),
			year: () => new Date().getFullYear(),
			styles
		},
	}
</script>

<style scoped lang="scss">
	@import "../../assets/scss/_variables";

	#footer {
		line-height: 18px;
		background: $blue;
		color: $bali;
		letter-spacing: .07px;

		.container {
			padding: 29px 40px;
			margin: 0 auto;
		}

		p {
			margin: 0 0 10px;
		}

		.footer-menu {

			li {
				padding: 0 20px 0 0;
			}

			a {
				color: $catskill;

				&:hover {
					color: $bali;
				}
			}
		}

		.footer-logo {
			width: 136px;

			a {
				display: block;
			}
		}

		a {
			&:hover {
				color: $white;
			}
		}
	}

	#widget-version{
		color: $gray;
		position: absolute;
		bottom: -4px;
		left: 1px;
		font-size: 8px;
	}
</style>
